import { useContext, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import AppContext from '../../contexts/AppContext';
import DataContext from '../../contexts/DataContext';
import EnphaseContext from '../../contexts/EnphaseContext';
import Button from '../../components/Button';

import Slide from '../components/Slide';
import SliderTooltip from '../components/SliderTooltip';
import { electricityBill as electricityBillPageData } from '../data/pages';

const DEFAULT_ELEC_BILL: number = 250;

export default function ElectricityBill() {
  const { currentPageIndex, setCurrentPageIndex } = useContext(AppContext);
  const { data, updateData } = useContext(DataContext);
  const { getInitialEnphaseData } = useContext(EnphaseContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const { dataKey, heading, nextPage } = electricityBillPageData;

  const [value, setValue] = useState(data.bill || DEFAULT_ELEC_BILL);
  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getInitialEnphaseData();
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      const rail = sliderRef.current?.querySelectorAll(
        '.rc-slider.rc-slider-horizontal'
      )[0];
      rail.setAttribute('data-zuko-tag-name', 'BUTTON');
      rail.setAttribute('data-zuko-id', 'electricity-bill-slider-rail');

      const handle =
        sliderRef.current?.querySelectorAll('.rc-slider-handle')[0];
      handle.setAttribute('data-zuko-tag-name', 'BUTTON');
      handle.setAttribute('data-zuko-id', 'electricity-bill-slider-handle');
    }
  }, [sliderRef]);

  const handleSliderChange = (value: number | number[]) => {
    setValue(value);
    updateData({ ...data, [dataKey]: value });
  };

  return (
    <>
      <Slide heading={heading} />
      <div className="select-none">
        <div className="mt-[90px] md:mt-[125px] flex justify-between flex-col md:flex-row">
          <div
            className="max-w-[279px] md:w-[400px] md:max-w-none relative"
            ref={sliderRef}>
            <Slider
              min={50}
              max={850}
              onChange={handleSliderChange}
              step={25}
              value={value}
            />
            <SliderTooltip value={value} />
          </div>
        </div>
        <div className="mt-[50px] md:mt-20">
          <Button
            action={() => {
              dataLayer.push({
                event: 'seform_monthly_electricity_bill',
                event_action: 'How much is your monthly electricity bill?',
                event_label: value,
              });

              updateData({
                ...data,
                [dataKey]: value,
              });

              // set current page index
              setCurrentPageIndex(currentPageIndex + 1);

              // update page param and navigate to next page
              searchParams.set('page', nextPage);
              setSearchParams(searchParams);
            }}
            data-zuko-id="bill_continue"
          />
        </div>
      </div>
    </>
  );
}
